import pagesNames from "../../constants/pages-names";

const environmentPageData = {
    header : {
        image : {
            name : "environment.jpg",
            alt : "Lake in front of hills",
        },
        title : "Environment",
    },
    sectionOne : {
        title : "Environmental Impact",
        borderBox : {
            title : "Overarching goal",
            subtitle : "Allocate financing towards a just and sustainable economy"
        },
        paraghraphOne : "In the past 40 years, SAB’s innovative banking and investment solutions have contributed to the growth of the national economy and the financial sector. As we look ahead to the next 40 years, SAB aims to be an economic agent that catalyses the emerging sustainable economy. We recognise that this economic transition brings with it an immense opportunity for green and sustainable growth. We are already seeing massive projects within the Kingdom, as the country positions itself as a global leader in sustainability. These include renewables, green hydrogen, sustainable tourism, and carbon sequestration.",
        paraghraphTwo : "Our partners and stakeholders are looking at SAB to manage ESG risks, but also capitalise on ESG opportunities. Thus far, our sustainability journey has proven that achieving sustainability imperatives and profitable growth are not incompatible objectives. We aim to be the bank of choice for clients looking to remodel their businesses to transition into a circular business model by utilising our refocused finance products and services.",
        paragraphThree : "At SAB, we believe there is room for everyone to benefit from the dividends of a sustainable economy. Our role is to support the Kingdom’s vision, enhance economic participation and build an inclusive economy that caters to MSMEs and diverse customers. In addition to SAB’s role within the economy as a green and sustainable financier, we intend to play an influential role within the financial community. Our strategic partnership with HSBC uniquely positions us to bring ESG talent, knowledge, and best practices into the financial ecosystem of Saudi Arabia.",
        paragraphFour : "We continued to advance the ESG agenda by participating in Stakeholder forums such as the 2023 COP 28 which was held in Dubai, UAE. This demonstrates our willingness to be part of unlocking sustainable economies and entrenching industry best practice. SAB was engaged as a toptier sponsor, reinforcing our commitment to green initiatives",
    },
    centerTitle : "Focus Areas",
    sectionTow : [
        {
            icon : "box.svg",
            title : "Sustainable products and services",
            subtitle : "Supporting customer transition"
        },
        {
            icon : "money.svg",
            title : "Sustainable finance And investments",
            subtitle : "Greening our financed portfolio"
        },
        {
            icon : "target.svg",
            title : "Achieve Net Zero",
            subtitle : "Transitioning our operations and supply chain"
        },
        {
            icon : "co2.svg",
            title : <span>Offset CO<sub>2</sub></span>,
            subtitle : "Planting 1 million trees"
        },
    ],
    subsection : {
        paragraphOne : "Vision 2030 seeks to preserve and enhance the Kingdom's natural environment and achieve Net Zero carbon emissions by 2060. SAB is aligned to this vision and has committed to achieving Net Zero within our operations by 2060, with a near-term milestone to achieve Net Zero emission in business operations by 2035. To achieve this goal, we are committing to deploy SAR 34 billion in capital towards sustainable finance and investments across our retail and corporate businesses.",
        paragraphTwo : "Since Scope 1 emissions within our operations are directly in our control, we have implemented a range of programmes to make a tangible and positive impact. These include reducing waste, paper, plastic, and power usage. Business travel is minimised, with video conferencing used for meetings wherever feasible. Outside our organisation, we have stepped up our efforts with the Saudi Green Initiative (SGI) and aligned our efforts towards several environmental sustainability initiatives through partnerships with non-profit organisations and government entities.",
        borderLeftBox : {
            title : "Continued progress",
            subtitle : "In 2022-23, SAB worked on increasing the its sustainable finance portfolio through engaging with corporate and retail clients.",
        },
    },
    sectionThree : {
        title : "Sustainable Products And Services",
        image : {
            src : "",
            alt : "shore (trees & sea)",
        }
    },
    sectionFour : [
        {
            icon : "half-earth.svg",
            title : "Kingdom’s First Green Deposit",
            subtitle : "In January 2022, we launched the first green deposit to allow retail clients to safely deposit their money in favour of green financing initiatives"
        },
        {
            icon : "earth.svg",
            title : "Red Sea Development",
            subtitle : "In March 2021, SAB acted as one of the mandated lead arrangers on the SAR 14 billion financing raised to fund the Red Sea project, and HSBC served as a green loan coordinator on the transaction"
        },
    ],
    sectionFive : {
        borderBox : {
            title : "Green deposits",
            subtitle : "Our sustainable financing initiatives are showing the way forward, with SAB being the first Saudi financing institution to initiate a green deposit. SAB’s green deposit brings together complementary Islamic banking and ESG principles and ensures that customer funds are managed following Shariah principles while contributing toward socially beneficial outcomes.",
        },
        paragraphOne : "The green deposit portfolio now accounts for 10.3% of the total product count of our Islamic term deposits held by our retail client base, having overachieved the target portfolio size which was fully matched against Islamic green loans and green Sukuk investments by SAB. This product outperformed SAB’s natural term deposit portfolio growth, with its innovative combination of features enabling a portfolio growth of 350% during the second half of 2022 for green deposits compared with 25% growth of the legacy Islamic term product. Over time, it is expected that the green deposit product will drive behaviour change amongst investors, and stimulate sustainable industries, not only in the Kingdom, but also throughout the region’s emerging economies. The matching investments for the green deposit are strategic projects under the Vision 2030 programme that may include key sectors such as sustainable energy diversity, energy efficiency, waste management, clean transportation, sustainable water management, and climate change adaptation activities. For non-financial support, the Bank has assembled a sustainable finance team to advise other economies in the Middle East region to achieve their climate targets.",
        tableOne : {
            headers : ["Green deposits product profile "],
            note : "SAB’s green deposit allows customers to safely deposit their money towards green financing initiatives, with these client funds generating competitive returns for short to medium-term investments.",
            data : [
                [
                    "Background",
                    "Our Retail Bank identified a growing awareness of ESG concepts among the customer base and changing customer attitudes. However, customers still expect financial returns equivalent to non-ESG products. Hence, both ESG and Islamic concepts dovetail into a specific term deposit that could help customers participate in ESG activities, while not compromising financial returns or religious preferences.",
                ],
                [
                    "Shariah-compliant ",
                    "Customer funds are managed in accordance with Shariah principles. ",
                ],
                [
                    "Sectors of focus",
                    "Funds may be matched against ESG lending activities across relevant sectors, and against sustainable investments in the green Sukuk. ",
                ],
                [
                    "Support of digital platforms ",
                    "SAB’s product journey is entirely digital and available 24/7. We have built end-to-end digital capabilities through our SABnet and SABmobile channels. The customer journey has been optimised to be as efficient as possible, with SABmobile allowing a green deposit account to be opened in 5 clicks and then managed directly through our digital channels. ",
                ],
                [
                    "Regular updates",
                    "Quarterly updates are provided to depositors. This ensures that depositors understand their role in contributing to ESG initiatives. They can see the specific ESG opportunities that are being supported and the role that the investor plays in supporting ESG projects. ",
                ],
                [
                    "Outcomes and future",
                    "In 2022, funds were matched against lending for solar energy and energy efficiency facilities, as a core component of the Kingdom’s aspiration to find solutions on efficiency and diversify the current energy mix. We seek to expand this product in 2023. ",
                ],
            ]
        },
        borderBoxTwo : {
            title : "Participating in green bonds",
            subtitle : "SAB participated in the Kingdom’s Public Investment Fund (PIF) debut green bonds. This first green issuance by a sovereign wealth fund is expected to raise billions of dollars. PIF gave initial price guidance for the green bonds at around 150 basis points over US Treasuries for a 5-year tranche, around 190 bps over UST for 10-year paper, and around 7-7.25% for a 100-year portion expected to raise USD 500 million.",
        },
    },
    sectionSix : {
        title : "Supporting small businesses",
        titleBorderLeft : "Overview",
        paragraphOne : "MSMEs are the backbone of economic growth, driving innovation and employment opportunities. Recognising their pivotal role, Saudi Vision 2030 aims to elevate MSMEs’ contribution to GDP from 20% to 35% by 2030. SAB supports around 18,000 active MSME customers increasingly through our digital offerings. As a key financier, SAB is committed to being a catalyst for MSMEs’ success. The tables below highlight the progress made toward enhancing the loan portfolio for the MSME business segment throughout the last three years:",
        paragraphTwo : "The size of our portfolio in the microenterprise segment has grown by 35% compared to 2021, whereas the size of our portfolio in the SME segment has grown by 59%. This demonstrates our commitment to the growth of our national economy and the objectives of Vision 2030. SAB offers a range of products and services to meet the needs of MSMEs including Shariah-compliant products. Customers receive a dedicated relationship manager (‘RM’) to assess their banking needs and provide solutions to meet their requirements. Two specialised teams serve MSME customers so that they can benefit from tailored support:",
        paragraphThree : <ul><li>A small- and micro-segment supports businesses with less than SAR 40 million turnover.</li><li>A medium segment that focuses on customers with a turnover of between SAR 40 million and SAR 200 million.</li></ul>,
        paragraphFour : "87 employees catering to MSME customers received 132 hours of training to better address the unique requirements of this segment. Our MSME teams are structured to effectively meet the diverse needs of MSMEs across various operational scales.",
        chartOneSection : {
            title : "Number of MSME customers with credit facilities",
            chart : {
                data : [
                    {
                        label : "2023",
                        cols : [{
                            number : 439,
                            color : "blue",
                        },{
                            number : 581,
                            color : "gray",
                        },{
                            number : 451,
                            color : "green"
                        }],
                    },
                    {
                        label : "2022",
                        cols : [{
                            number : 444,
                            color : "blue",
                        },{
                            number : 506,
                            color : "gray",
                        },{
                            number : 369,
                            color : "green"
                        }],
                    },
                    {
                        label : "2021",
                        cols : [{
                            number : 457,
                            color : "blue",
                        },{
                            number : 465,
                            color : "gray",
                        },{
                            number : 370,
                            color : "green"
                        }],
                    },
                ],
                xAxis : [0, 100, 200, 300, 400, 500, 600],
                labels : [
                    {
                        name : "Micro",
                        color : "green",
                    },
                    {
                        name : "Small",
                        color : "gray",
                    },
                    {
                        name : "Medium",
                        color : "blue",
                    },
                ],
            }
        },
        chartSectionTwo : {
            title : "Composition of loan portfolio (Value of loan portfolio by size (SAR million))",
            chartOne : {
                title : "Micro-enterprise",
                cols : [
                    {
                        year : "2023",
                        color : "blue",
                        value : 1515,
                    },
                    {
                        year : "2022",
                        color : "gray",
                        value : 1616,
                    },
                    {
                        year : "2021",
                        color : "gray",
                        value : 1119,
                    },
                ],
                xAxis : ["0", "5,00", "1,000", "1,500", "2,000"],
                maxValue : 2000,
            },
            chartTwo : {
                title : "SME",
                cols : [
                    {
                        year : "2023",
                        color : "blue",
                        value : 9513,
                    },
                    {
                        year : "2022",
                        color : "gray",
                        value : 9269,
                    },
                    {
                        year : "2021",
                        color : "gray",
                        value : 5993,
                    },
                ],
                xAxis : ["0", "4,000", "8,000", "10,000", "12,000"],
                maxValue : 12000,
            },
            chartThree : {
                title : "Large and others",
                cols : [
                    {
                        year : "2023",
                        color : "blue",
                        value : 155868,
                    },
                    {
                        year : "2022",
                        color : "gray",
                        value : 130662,
                    },
                    {
                        year : "2021",
                        color : "gray",
                        value : 126527,
                    },
                ],
                xAxis : ["0", "110,000", "120,000", "130,000", "140,000"],
                maxValue : 140000,
            },
        }
    },
    sectionSeven : {
        borderTitleOne : "MSME support ventures",
        subSections : [
            {
                title : "Supporting MSMEs through Strategic Partnerships",
                subtitle : <p>Through strategic initiatives and partnerships, SAB actively engaged in various programmes to foster entrepreneurship, provide essential financial aid, and facilitate access to critical resources for MSMEs. In 2023, SAB provided support via a few main initiatives:<ul><li>During 2023, in support of Visions 2030, SAB introduced a series of free to join seminars to educate MSME on different facets of developing and growing an MSME enterprise in the Kingdom.</li><li>The bank supported MSMEs through engagement with the Real Estate Development Fund (REDF), the Tourism Development Fund (TDF), and the National Technology Development Programme (NTDP).</li><li>Through Kafalah, SAB facilitates financing for MSMEs in cooperation with the Saudi Industrial Development Fund. The Kafalah programme enables MSME funding of up to SAR 15 million and services to eligible clients. It cooperates with the Saudi Industrial Development Fund (SIDF), focusing on Shariah-compliant solutions.</li><li>SAB also partners with Monsha’at, the General Authority for Small and Medium Enterprises, through co-financing for banks’ customers, and with the SME Bank of Saudi Arabia.</li></ul></p>,
            },
            {
                title : "",
                subtitle : "",
            },
            {
                title : "",
                subtitle : "",
            },
            {
                title : "",
                subtitle : "",
            },
        ],
        borderTitleTwo : "",
        paragraphOne : ""
    },
    sectionSevent : {   
        title : "SAB’s sector-specific lending portfolio",
        paragraphOne : "SAB aims to measure the carbon footprint of our portfolio, in order to achieve Net Zero by 2060 or sooner. In line with the SASB reporting requirements for commercial banks, the following table outlines the industry breakdown of SAB’s lending book at 31 December 2022. ",
        borderTitle : "Comparison of total exposure by sectors",
        chartImage : {
            image : "chart-one.png",
            alt : "",
        }
    },
    sectionEight : [
        {
            image : {
                name : "img-2.jpg",
                alt : "Light Cross the trees",
            },
            title : "Social Impact",
            subtitle : "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-5.jpg",
                alt : "a person using a laptop",
            },
            title : "Overarching Goal",
            subtitle : "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making.",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-4.jpg",
                alt : "A woman helps a child",
            },
            title : "Sustainability in Our Operations",
            subtitle : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
    ]
};

export default environmentPageData;